// useSelectVideo.js
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectVideoAll } from '../redux/ApiSlice/WatchVideoSlice';
import { watchVideos } from '../redux/ApiSlice/HomePageVideoSlice';

const useSelectVideo = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectVideo = async (id, videos, prevpath, feedType, nextPage) => {
        // await dispatch(selectVideoAll(videos));
        await dispatch(watchVideos(videos));
        navigate(`/watch/${id}${feedType ? `?feedType=${feedType}` : ''}`, { state: { from: prevpath, feedType: feedType, nextPage } });
    };

    return selectVideo;
};

export default useSelectVideo;